import React from 'react';
import PartnersPrestataire from '../PartnersPrestataire/PartnersPrestataire';
import APOTHEO_PRESTA_AJPL from '../../images/prestataires/APOTHEO_PRESTA_AJPL.png';
import APOTHEO_PRESTA_ASCA from '../../images/prestataires/APOTHEO_PRESTA_ASCA.png';
import APOTHEO_PRESTA_CA_SAFFICHE from '../../images/prestataires/APOTHEO_PRESTA_CA_SAFFICHE.png';
import APOTHEO_PRESTA_DATAE from '../../images/prestataires/APOTHEO_PRESTA_DATAE.png';
import APOTHEO_PRESTA_DYNAMIZ from '../../images/prestataires/APOTHEO_PRESTA_DYNAMIZ.png';
import APOTHEO_PRESTA_PHARMAO from '../../images/prestataires/APOTHEO_PRESTA_PHARMAO.png';
import APOTHEO_PRESTA_PHARMAPRIVILEGE from '../../images/prestataires/APOTHEO_PRESTA_PHARMAPRIVILEGE.png';
import './PartnersPrestataires.css';

const prestataires = [
  {
    image: APOTHEO_PRESTA_CA_SAFFICHE,
    label: 'Création, éditions et impressions covering et flyer',
  },
  {
    image: APOTHEO_PRESTA_PHARMAO,
    label: 'Livraison à domicile',
  },
  {
    image: APOTHEO_PRESTA_DYNAMIZ,
    label: 'Écrans et monétisation',
  },
  {
    image: APOTHEO_PRESTA_PHARMAPRIVILEGE,
    label: 'Écrans et monétisation',
  },
  {
    image: APOTHEO_PRESTA_DATAE,
    label: 'Mise en conformité et suivi réglementation RGPD',
  },
  {
    image: APOTHEO_PRESTA_ASCA,
    label: 'Étiquetage électronique',
  },
  {
    image: APOTHEO_PRESTA_AJPL,
    label: 'Réfrigérateur',
  },
];

const PartnersPrestataires = () => {
  return (
    <div className="PartnersPrestataires" id="prestataires">
      <div className="PartnersPrestataires__title">Prestataires</div>
      <div className="PartnersPrestataires__prestataires">
        {prestataires.map((prestataire, index) => (
          <PartnersPrestataire
            key={index}
            image={prestataire.image}
            label={prestataire.label}
          />
        ))}
      </div>
    </div>
  );
};

export default PartnersPrestataires;
